import { css } from '@emotion/core'

import { tableBodyTdStyle } from '@/constants/layout'

/** 操作ログ一覧テーブル（列幅を固定し、セル内で ellipsis させる） */
export const operationLogTableStyle = css({
  width: '100%',
  borderCollapse: 'collapse',
  tableLayout: 'fixed',
})

export const operationLogListScrollStyle = css({
  overflowY: 'auto',
  overflowX: 'hidden',
})

export const operationLogCellEllipsisStyle = css({
  display: 'block',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
})

/** table-layout: fixed 時に ellipsis を効かせる td */
export const operationLogTdEllipsisStyle = css(tableBodyTdStyle, {
  fontWeight: 'bold',
  overflow: 'hidden',
  maxWidth: 0,
})

export const operationLogTdNowrapStyle = css(tableBodyTdStyle, {
  fontWeight: 'bold',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
})

/** 操作日時など日付時刻は省略せず全文表示 */
export const operationLogTdDatetimeStyle = css(tableBodyTdStyle, {
  fontWeight: 'bold',
  whiteSpace: 'nowrap',
  overflow: 'visible',
  textOverflow: 'clip',
  minWidth: 170,
})
